import { render, staticRenderFns } from "./garden2.vue?vue&type=template&id=6c0754ac"
import script from "./garden2.vue?vue&type=script&lang=js"
export * from "./garden2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports